// Shared JavaScript
let html = document.getElementsByTagName('html')[0];
let body = document.getElementsByTagName('body')[0];

// Mobile navigation
var mobileNavToggle = document.querySelector('.mobile-nav-trigger-button');
var header = document.querySelector('.global-header');

mobileNavToggle.onclick = function() {
  html.classList.toggle('mobile-menu-open');
  html.classList.remove("nav-blackout-enabled");
  header.classList.remove("search-open");
  searchField.blur();
}

// Navigation blackout effect
var childLinkNav = document.getElementsByClassName('has-child-links');
for (z = 0; z < childLinkNav.length; z++) {
  childLinkNav[z].addEventListener('mouseover', changeDefOver, false);
  childLinkNav[z].addEventListener('mouseout', removeBlackout, false);
}

function changeDefOver() {
  html.classList.add('nav-blackout-enabled');
  header.classList.remove("search-open");
  searchField.blur();
}

var blackout = document.querySelector('.nav-blackout')
blackout.addEventListener('mouseover', removeBlackout);

function removeBlackout() {
  html.classList.remove('nav-blackout-enabled');
  header.classList.remove("search-open");
  searchField.blur();
}

// Search navigation
var searchToggle = document.querySelector('.search-button');
var searchField = document.querySelector('#search-input-field');
searchToggle.addEventListener('mouseover', openSearch, false);
searchToggle.addEventListener('click', openSearch, false);

function openSearch() {
  header.classList.add("search-open")
  html.classList.add("nav-blackout-enabled");
  html.classList.remove('mobile-menu-open');
  searchField.focus();
}

// Offset scroll
var scrollPosition = window.scrollY;
window.addEventListener('scroll', function() {
    scrollPosition = window.scrollY;
    if (scrollPosition >= 37) {
        html.classList.add('nav-offset');
    } else {
        html.classList.remove('nav-offset');
    }

});



// Accordions
var accItem = document.getElementsByClassName('accordion');
var accHD = document.getElementsByClassName('accordion-toggle');
for (i = 0; i < accHD.length; i++) {
    accHD[i].addEventListener('click', toggleItem, false);
}

function toggleItem() {
    var itemClass = this.parentNode.className;
    for (i = 0; i < accItem.length; i++) {
        accItem[i].className = 'accordion closed';
    }
    if (itemClass == 'accordion closed') {
        this.parentNode.className = 'accordion open';
    }
}

// Nav accordions
var navChildMenu = document.getElementsByClassName('has-child-links');
var navChildToggle = document.getElementsByClassName('childnav-open');
for (g = 0; g < navChildToggle.length; g++) {
    navChildToggle[g].addEventListener('click', openChildNav, false);
}
var navChildClose = document.getElementsByClassName('childnav-back');
for (h = 0; h < navChildClose.length; h++) {
  navChildClose[h].addEventListener('click', closeChildNav, false);
}

function openChildNav() {
    var childNavClass = this.parentNode.parentNode.className;
    for (i = 0; i < navChildMenu.length; i++) {
        navChildMenu[i].className = 'header-navigation-single has-child-links closed';
    }
    if (childNavClass == 'header-navigation-single has-child-links closed') {
        this.parentNode.parentNode.className = 'header-navigation-single has-child-links open';
    }
}

function closeChildNav() {
  this.parentNode.parentNode.parentNode.className = 'header-navigation-single has-child-links closed';
}





// Modals
var modalToggle = document.getElementsByClassName('modal-toggle');
for (m = 0; m < modalToggle.length; m++) {
  modalToggle[m].addEventListener('click', openModal, false);
}
 
function openModal() {
  var modalTarget = this.dataset.modaltarget;
  // console.log(modalTarget);
  html.classList.add('modal-on');
  var modalTargetEl = document.getElementById(modalTarget);
  modalTargetEl.classList.add("enabled");
  modalTargetEl.focus;
}

var closeModalToggle = document.getElementsByClassName('close-modal');
for (n = 0; n < closeModalToggle.length; n++) {
  closeModalToggle[n].addEventListener('click', closeModal, false);
}
 
function closeModal() {
  var modalTarget = this.dataset.modaltarget;
  var modalTargetEl = document.getElementById(modalTarget);
  html.classList.remove('modal-on');
  modalTargetEl.classList.remove("enabled");
  var returnFocus = this.dataset.returnfocus;
  returnFocus.focus;
}



// Swiper sliders
var sliderProductImages = new Swiper('.swiper-product-images', {
  speed: 400,
  autoplay: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  spaceBetween: 8,
  centeredSlidesBounds: true,
});

var sliderProducts = new Swiper('.swiper-product-slider', {
  speed: 400,
  autoplay: false,
  slidesPerView: 2,
  spaceBetween: 8,
  breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    }
});

var sliderPress = new Swiper('.swiper-press-slider', {
  speed: 400,
  autoplay: true,
  slidesPerView: 1,
  spaceBetween: 8,
  breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    }
});

var sliderPressLogos = new Swiper('.subsection-press-slider', {
  speed: 400,
  autoplay: true,
  slidesPerView: 2,
  spaceBetween: 0,
  breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 12
      }
    }
});

var sliderUGC = new Swiper('.ugc-swiper', {
  speed: 400,
  autoplay: true,
  slidesPerView: 2,
  spaceBetween: 8,
  breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 12
      }
    }
});

var sliderBanner = new Swiper('.swiper-hero-banners', {
  speed: 400,
  autoplay: true,
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 0
    }
  }
});

var honorRoller = new Swiper('.honor-roller-slider', {
  speed: 400,
  autoplay: true,
  slidesPerView: 2,
  spaceBetween: 8,
  breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    }
});

var collectionSlider = new Swiper('.collection-slider', {
  speed: 400,
  autoplay: true,
  slidesPerView: 2,
  spaceBetween: 8,
  breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    }
});

var sliderBanner = new Swiper('.swiper-lookbook', {
  speed: 400,
  autoplay: true,
  slidesPerView: 1,
  spaceBetween: 16,
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 32
    }
  }
});

function changeQuantity() {
  var quantityValue = this.dataset.value;
  quantity_input.value = quantityValue;

  for (q = 0; q < quantity_selector.length; q++) {
    quantity_selector[q].classList.remove('quantity-active');
  }
  this.classList.add("quantity-active");
}

window.addEventListener("scroll", function() {
  var elementTarget = document.getElementById("pdp-main");
  if (elementTarget) {  // Only proceed if element exists
    if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight)) {
      html.classList.add('pdp-bar-on');
    } else {
      html.classList.remove('pdp-bar-on');
    }
  }
});